import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    submitted: false,
    loading: false,
    error: false,
    errorMessage: '',
    errorMessageData: ''
}

export const userRegistrationSlice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        registrationInProgress: () => {
            return {
                ...initialState,
                loading: true
            }
        },
        registrationProcessed: (state, { payload }) => {
            return {
                ...initialState,
                ...payload,
                submitted: !payload.error
            }
        }
    }
})

export const { registrationInProgress,registrationProcessed } = userRegistrationSlice.actions;

export default userRegistrationSlice.reducer;